import {Component, Input} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";
import {BacklogService} from "../../../../core/services/backlog.service";

@Component({
  selector: 'app-cancel-service',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    NgClass,
    NgIf
  ],
  templateUrl: './cancel-service.component.html',
  styleUrl: './cancel-service.component.scss'
})
export class CancelServiceComponent {
  @Input() confirmAction!: () => void;
  @Input() data: any;
  public validate: boolean = false;
  public reasonList: any = [];
  public cancelServiceForm: FormGroup;

  constructor(public modal :NgbModal, private fb: FormBuilder, private generalService: GeneralService,private tableService: TableService,private backlogService: BacklogService) {
    this.cancelServiceForm = this.fb.group({
      service_id: [""],
      reason_id: ["", Validators.required],
      cancellation_cost: ["", Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"Motivo cancelacion",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {
      this.reasonList = value;
    });
  }

  cancelService(){
    if (this.cancelServiceForm.valid) {
      this.cancelServiceForm.get('service_id')?.setValue(this.data.idService);
      this.backlogService.actionBacklog(this.cancelServiceForm.value,'cancelservice').subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              this.confirmAction();
            }
          },
          (err) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    } else {
      this.cancelServiceForm.markAllAsTouched();
      this.generalService.showMessage('warn', 'LLene toda la información solicitada');
    }
  }

  loadList(config: any, setVariable: (value: any) => void):void {
    this.tableService.loadSelectOptions(config).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            setVariable([]);
          } else {
            setVariable(res['message']);
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          setVariable([]);
        }
    );
  }

  get reasonId() {
    return this.cancelServiceForm.get("reason_id");
  }



}
